import { render, staticRenderFns } from "./CadastrarEditarCalendarioDialog.vue?vue&type=template&id=73f7ad80"
import script from "./CadastrarEditarCalendarioDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarCalendarioDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports